import React from 'react';
import { motion } from 'framer-motion';
import { ClockIcon, PhoneIcon } from 'lucide-react';
export function OpeningHoursSection() {
  return <section className="py-24 bg-beige relative" data-id="element-140">
      <div className="max-w-7xl mx-auto px-6" data-id="element-141">
        <div className="bg-weiss rounded-3xl p-10 md:p-16 shadow-xl shadow-sand/50 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-142">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-143">
            <h2 className="text-3xl md:text-4xl font-heading text-schwarz mb-4" data-id="element-144">
              Praxis-Öffnungszeiten auch für Berufstätige
            </h2>
            <h3 className="text-xl text-royal-blue mb-6 font-heading" data-id="element-145">
              Ihre Zahngesundheit im Alltag unterbringen!
            </h3>
            <p className="text-warm-gray leading-relaxed mb-8 font-body" data-id="element-146">
              Wer mitten im Berufsleben steht, schafft es oft nicht einen
              Zahnarztbesuch im Alltag unterzubringen! Wir bieten auch nach
              Feierabend noch Sprechzeiten an und behandeln Sie von Montag bis
              Donnerstag noch bis 20 Uhr. Auch am Freitag bieten wir Ihnen bis
              20 Uhr einen Termin an. Und falls das Alles auch nicht hilft, sind
              wir am Samstag bis 14 Uhr für Sie im Einsatz! Denn Ihre
              Zahngesundheit kann nicht warten!
            </p>

            <a href="tel:091156836360" className="inline-flex items-center space-x-3 text-lg font-heading text-schwarz hover:text-royal-blue transition-colors group" data-id="element-147">
              <div className="w-12 h-12 rounded-full bg-sand flex items-center justify-center group-hover:bg-royal-blue group-hover:text-weiss transition-colors" data-id="element-148">
                <PhoneIcon className="w-5 h-5" data-id="element-149" />
              </div>
              <span data-id="element-150">0911-56 83 63 60</span>
            </a>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="bg-weiss rounded-2xl p-8 border border-sand" data-id="element-151">
            <div className="flex items-center space-x-4 mb-8" data-id="element-152">
              <ClockIcon className="w-8 h-8 text-royal-blue" data-id="element-153" />
              <h4 className="text-2xl font-heading text-schwarz" data-id="element-154">
                Unsere Zeiten
              </h4>
            </div>

            <ul className="space-y-6 font-body" data-id="element-155">
              <li className="flex justify-between items-center border-b border-sand pb-4" data-id="element-156">
                <span className="font-medium text-schwarz" data-id="element-157">
                  Montag – Donnerstag
                </span>
                <span className="text-warm-gray" data-id="element-158">08:00 – 20:00 Uhr</span>
              </li>
              <li className="flex justify-between items-center border-b border-sand pb-4" data-id="element-159">
                <span className="font-medium text-schwarz" data-id="element-160">Freitag</span>
                <span className="text-warm-gray" data-id="element-161">08:00 – 20:00 Uhr</span>
              </li>
              <li className="flex justify-between items-center" data-id="element-162">
                <span className="font-medium text-royal-blue" data-id="element-163">Samstag</span>
                <span className="text-royal-blue font-medium" data-id="element-164">
                  08:00 – 14:00 Uhr
                </span>
              </li>
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}